import React, {useReducer} from 'react';
import './App.css';
import LiveChatAdmin from './component/livechatadmin/LiveChatAdmin';
import OperatorSimulator from './component/livechatadmin/OperatorSimulator';
import PseudoForm from './component/livechatadmin/PseudoForm';

function App() {
  const initialState = ({
    operator_list: [],
    active_operator_display: false,
    active_operator_id: 0,
    active_operator_pseudo: '',
    active_operator_name: '',
    active_communication: [],
    com_list: [],
    user_pseudo: 'Pascal',
    current_operator_id: '',
    chat_id: 0,
    com_offset: 10,
    current_communication: '',
    pseudo: '',
    pseudo_isValid: false,
  })
  const livechat_admin_reducer = (state, action) => {
    // console.log('action type : ', action.type, action.payload)
    if (action.type === 'change_user_pseudo') {
      return {
        ...state,
        pseudo: action.payload.pseudo,
        pseudo_isValid: action.payload.pseudo_isValid,
      };
    }
    if (action.type === 'change_chat_id') {
      return {...state, chat_id: action.payload.chat_id};
    }
    if (action.type === 'change_active_communication') {
      return {...state, active_communication: action.payload.active_communication};
    }
    if (action.type === 'change_current_communication') {
      return {...state, current_communication: action.payload.current_communication};
    }
    if (action.type === 'change_current_operator_id') {
      return {...state, current_operator_id: action.payload.current_operator_id};
    }
    if (action.type === 'change_operator_list') {
      return {...state, operator_list: action.payload.operator_list};
    }
    if (action.type === 'change_com_list') {
      return {...state, com_list: action.payload.com_list};
    }
    if (action.type === 'change_com_offset') {
      let n = parseInt(action.payload.com_offset) + 1;
      return {...state, com_offset: n};
    }
    if (action.type === 'change_active_operator') {
      return {
        ...state,
        active_operator_display: action.payload.active_operator_display,
        active_operator_id: action.payload.active_operator_id,
        active_operator_pseudo: action.payload.active_operator_pseudo,
        active_operator_name: action.payload.active_operator_name,
      };
    }
    throw Error('Unknown action.');
  }
  const [state, dispatch] = useReducer(livechat_admin_reducer, initialState);

  return (
    <div className="App">
      <div className="webmasterLink">
        <a
          href="https://www.pascalcosta.fr"
          target="_blank"
          rel="noreferrer">Webmaster</a>
      </div>
      <header className="App-header">
        <div className="logoContainer">
          <img
            src={process.env.REACT_APP_IMAGE_URL +'/LIVECHAT-icon.png'}
            alt="LIVECHAT admin icon" />
        </div>
        <div className="h1Container">
          <h1>LIVE CHAT - admin</h1>
          {state.pseudo_isValid && (
            <p className="display_pseudo">{'Votre pseudo : ' + state.pseudo}</p>
          )}
        </div>
        {window.screen.width > 700 && state.pseudo_isValid && (
          <OperatorSimulator state={state} dispatch={dispatch} />
        )}
        {window.screen.width > 700 && !state.pseudo_isValid && (
          <PseudoForm  state={state} dispatch={dispatch} />
        )}
      </header>
      {window.screen.width > 700 ? (
          <section>
            <LiveChatAdmin state={state} dispatch={dispatch} />
          </section>
      ) : (
        <div
          className="ask_pseudo_container"
          style={{color: 'white', fontSize: '20px', padding: '25px', textAlign: 'center'}}>
            <p>
              <span style={{marginLeft: '30px'}}></span>
              L'interface administrateur est conçut pour des écrans d'ordinateurs. 
              Utilisez un écran de plus de 700 pixels de large svp.
            </p>
        </div>
      )}
    </div>
  );
}

export default App;
